module.exports = __webpack_public_path__ + "img/Close_Button.b7e976ee.svg";